<template>
<div id="contacts">
    <div class="info title contacts clearfix">
        <div class="wrapper clearfix">
            <div class="col-xs-120">
                <h1>Контактная информация</h1>
            </div>
        </div>
    </div>
    <div class="country">
        <div class="wrapper clearfix">
            <div class="col-lg-30 col-sm-60 no-padding">
                <div class="block">
                    <img src="/static/img/general/flag-russia.png">
                    <span>Россия</span>
                </div>
            </div>
            <div class="col-lg-30 col-sm-60 no-padding">
                <div class="block">
                    <img src="/static/img/general/flag-ukr.png">
                    <span>Украина</span>
                </div>
            </div>
            <div class="col-lg-30 col-sm-60 no-padding">
                <div class="block">
                    <img src="/static/img/general/flag-bel.png">
                    <span>Беларусь</span>
                </div>
            </div>
            <div class="col-lg-30 col-sm-60 no-padding">
                <div class="block">
                    <img src="/static/img/general/flag-europe.png">
                    <span>Восточная Европа</span>
                </div>
            </div>
        </div>
    </div>
    <div class="country-more clearfix">
        <div class="wrapper clearfix">
            <div class="col-lg-30 col-sm-60 no-padding">
                <div class="block">
                    <h3>ООО “Эчив Райт Нау”</h3>
                    <div class="city">г. Москва</div>
                    <div class="location">ул. Автозаводская, д. 23</div>
                    <div class="phone">8 800 123-45-67</div>
                    <div class="marketing">Отдел маркетинга
                        <router-link to="#">marketing@v-avtoservis.ru</router-link>
                    </div>
                    <div class="press-center">Пресс-центр
                        <router-link to="#">pr@v-avtoservis.ru</router-link>
                    </div>
                    <div class="staff">Отдел персонала
                        <router-link to="#">personal@v-avtoservis.ru</router-link>
                    </div>
                </div>
            </div>
            <div class="col-lg-30 col-sm-60 no-padding">
                <div class="block">
                    <h3>ООО “Ечiв Райт Нау”</h3>
                    <div class="city">г. Киев</div>
                    <div class="location">ул. Московская, д. 36</div>
                    <div class="phone">+38 (044) 123-45-67</div>
                    <div class="marketing">Отдел маркетинга
                        <router-link to="#">marketing@v-avtoservis.ua</router-link>
                    </div>
                    <div class="press-center">Пресс-центр
                        <router-link to="#">pr@v-avtoservis.ua</router-link>
                    </div>
                    <div class="staff">Отдел персонала
                        <router-link to="#">personal@v-avtoservis.ua</router-link>
                    </div>
                </div>
            </div>
            <div class="col-lg-30 col-sm-60 no-padding">
                <div class="block">
                    <h3>ООО “Эчив Райт Нау”</h3>
                    <div class="city">г. Минск</div>
                    <div class="location">ул. Могилёвская, д. 4</div>
                    <div class="phone">+375 (17) 123-45-67</div>
                    <div class="marketing">Отдел маркетинга
                        <router-link to="#">marketing@v-avtoservis.by</router-link>
                    </div>
                    <div class="press-center">Пресс-центр
                        <router-link to="#">pr@v-avtoservis.by</router-link>
                    </div>
                    <div class="staff">Отдел персонала
                        <router-link to="#">personal@v-avtoservis.by</router-link>
                    </div>
                </div>
            </div>
            <div class="col-lg-30 col-sm-60 no-padding">
                <div class="block">
                    <h3>Achieve Right Now LLC</h3>
                    <div class="city">Riga</div>
                    <div class="location">Vilandes st, 7</div>
                    <div class="phone">+371 (2) 123-45-67</div>
                    <div class="marketing">Отдел маркетинга
                        <router-link to="#">marketing@v-avtoservis.eu</router-link>
                    </div>
                    <div class="press-center">Пресс-центр
                        <router-link to="#">pr@v-avtoservis.eu</router-link>
                    </div>
                    <div class="staff">Отдел персонала
                        <router-link to="#">personal@v-avtoservis.eu</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'Contacts'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Contacts.vue